import { render, staticRenderFns } from "./AddNewChildModal.vue?vue&type=template&id=e6ae4770&scoped=true&"
import script from "./AddNewChildModal.vue?vue&type=script&lang=js&"
export * from "./AddNewChildModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewChildModal.vue?vue&type=style&index=0&id=e6ae4770&lang=scss&scoped=true&"
import style1 from "./AddNewChildModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ae4770",
  null
  
)

export default component.exports